// D:\brickbucket_v3.1\Brickbucket_Frontend_V3.1\src\ConsumerApp\api\orders\orders.service.js

import { apiClient } from '../apiClient';

export const OrdersService = {
  getOrdersByCustomer: async (customerId) => {
    if (!customerId) throw new Error('Customer ID is required');
    const response = await apiClient.get(
      `/brickbucket/customer/salesorder/get-orders-by-customer?customer_id=${customerId}`
    );
    return response;
  },

  getOrderById: async (orderId) => {
    if (!orderId) throw new Error('Order ID is required');
    const response = await apiClient.get(
      `/brickbucket/customer/salesorder/get-customer-order-by-orderId?order_id=${orderId}`
    );
    return response;
  },

  getOrderDetails: async (orderId) => {
    return OrdersService.getOrderById(orderId);
  },

  getInvoicesByOrderId: async (orderId) => {
    const response = await apiClient.get(
      `/brickbucket/invoice/get-all-invoices-by-order-id?order_id=${orderId}`
    );
    return response?.data || response;
  },

  cancelOrder: async (payload) => {
    const response = await apiClient.post(
      `/brickbucket/customer/salesorder/cancel-salesorder-or-deliverygroup`,
      payload
    );
    return response?.data || response;
  },

  requestReturn: async (formData) => {
    const response = await apiClient.post(
      `/brickbucket/customer/salesorder/request-return`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response?.data || response;
  },
};